import NotificationConverter from 'scripts/application/dto_converters/notification_converter';
import ShowConversationSystemNotification from 'actions/notification/show_conversation_system_notification';
import DismissNotification from 'actions/notification/dismiss_notification';

export function createAndShowNotification(context, eventDto) {
  const notification = NotificationConverter.fromDto(eventDto);
  context.stores.notifications.addOrReplace(notification);
  DismissNotification.schedule(context, { id: notification.id });
  context.executeAction(ShowConversationSystemNotification, notification);
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/notification/lib/show_notification.js